import { jsx as _jsx } from "react/jsx-runtime";
import { BtnFactory, SIZE } from './BtnFactory';
export { SIZE };
export function CtaBtn(props) {
    return _jsx(BtnFactory, { as: 'button', severity: 'cta', ...props });
}
//# sourceMappingURL=CtaBtn.js.map